import { render } from "./PageSpinner.vue?vue&type=template&id=76a1d12a"
import script from "./PageSpinner.vue?vue&type=script&lang=js"
export * from "./PageSpinner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__